
<!--US Page-->
<style>
  .mbfs-home-hero_2{
    height: 700px;
  }
  @media (max-width: 768px) {
    .mbfs-home-hero_2{
      height: 1100px;
    }
  }
</style>
<div class="dtfinsurance">
  <!--Announcement Banner Code-->
  <!-- <div class="dtf-alertpage"></div> -->


  <!--Banner-->
  <section class="mbfs-home-hero_2"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Dynamic_Lease_Carousel_1140x400_1123.jpg);">
    <section class="mbfs-home-hero_2__header">
      <div class="shortrow" [style.gap.px]="isFrench ? 90 : 10">
        <div>
        <h2 class="mbfs-home-hero_2__header-subtitle" style="text-align: justify;" [style.fontSize.px]="isFrench ? 43 : 44">
          {{ 'DynamicPortal.TruckTitleLease' | translate }}
        </h2>
        <p class="mbfs-home-hero_2__header-text" style="text-align: justify; margin-right: 30px;">
          {{ 'DynamicPortal.TruckHeaderLease' | translate }}
        </p>
      </div>
        <div *ngIf="!isCanadaPortal" style="padding: 10px;" class="dtf-dynamicleaseformpage"></div>
        <div *ngIf="isCanadaPortal" style="padding: 10px;" class="dtf-dynamicleaseformpageca"></div>

     </div>
    </section>
  </section>

  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'DynamicPortal.InsuranceHeaderLease' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'DynamicPortal.InsuranceCopy1Lease' | translate }}</p>
      </div>
    </div>
  </section>

  <!--Benefits you can count on 1-->
  <!-- <div class="mercedes-me-login__column">
    <h2 class="mercedes-me-login__column-headline"></h2>
    <ul class="dtfbrochures__columns2">
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/TELEMATICS-BASED_icon.png">
        <h4 class="header1"> {{ 'DynamicPortal.BenefitsTitle1Lease' | translate }}</h4>
        <p class="paragraph1"> {{ 'DynamicPortal.BenefitsCopy1Lease' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/PAY-AS-YOU-GO_Icon.png">
        <h4 class="header1"> {{ 'DynamicPortal.BenefitsTitle2Lease' | translate }}</h4>
        <p class="paragraph1"> {{ 'DynamicPortal.BenefitsCopy2Lease' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/ALIGN_USAGE-CASH FLOW_Icon.png">
        <h4 class="header1">{{ 'DynamicPortal.BenefitsTitle3Lease' | translate }}</h4>
        <p class="paragraph1">{{ 'DynamicPortal.BenefitsCopy3Lease' | translate }}</p>
      </li>
    </ul>
  </div> -->

  <div class="benefits-section" style="padding: 10px;">
    <h2 class="benefits-title"></h2>
    <ul class="benefits-row">
      <li class="benefit-card">
        <img src="static/assets/img/dtf-assets/images/redesign/TELEMATICS-BASED_icon.png" class="benefit-icon">
        <h4 class="benefit-heading">{{ 'DynamicPortal.BenefitsTitle1Lease' | translate }}</h4>
        <p class="benefit-text">{{ 'DynamicPortal.BenefitsCopy1Lease' | translate }}</p>
      </li>
      <li class="benefit-card">
        <img src="static/assets/img/dtf-assets/images/redesign/PAY-AS-YOU-GO_Icon.png" class="benefit-icon">
        <h4 class="benefit-heading">{{ 'DynamicPortal.BenefitsTitle2Lease' | translate }}</h4>
        <p class="benefit-text">{{ 'DynamicPortal.BenefitsCopy2Lease' | translate }}</p>
      </li>
      <li class="benefit-card">
        <img src="static/assets/img/dtf-assets/images/redesign/ALIGN_USAGE-CASH FLOW_Icon.png" class="benefit-icon">
        <h4 class="benefit-heading">{{ 'DynamicPortal.BenefitsTitle3Lease' | translate }}</h4>
        <p class="benefit-text">{{ 'DynamicPortal.BenefitsCopy3Lease' | translate }}</p>
      </li>
    </ul>
  </div>

  <div *ngIf="!isCanadaPortal">
    <!-- Protect Your investment-->
    <div class="dtfbrochures__page3">
      <div class="dtfbrochures__container2">
        <h4 class="dtfbrochures__header2" style="color: white;">{{ 'DynamicPortal.FinancingHeaderLease' | translate }}</h4>
        <p class="dtfbrochures__paragraph3">{{ 'DynamicPortal.FinancingParagraphLease' | translate }} <br><br>
          <a target="_blank" class="mbfs-button-1" href="static/assets/pdf/DTF_DynamicFinancing_Brochure_LoRes.pdf">{{
            'DynamicPortal.DYLBrochureButton' | translate }}</a>
          <br><br>
        </p>
        <div class="dtfbrochures__columns2">
          <div class="row5">
            <div class="col-sm-4">
              <img class="smallimg2" src="static/assets/img/dtf-assets/images/redesign/SEASONAL_BUSINESS_CUSTOMERS.png">
              <h4> {{ 'DynamicPortal.FinancingTitle1Lease' | translate }}</h4>
              <p class="paragraph2"> {{ 'DynamicPortal.FinancingCopy1Lease' | translate }}</p>
            </div>
            <div class="col-sm-4">
              <img class="smallimg2" src="static/assets/img/dtf-assets/images/redesign/IRREGULAR_ROUTES.png">
              <h4> {{ 'DynamicPortal.FinancingTitle2Lease' | translate }}</h4>
              <p class="paragraph2"> {{ 'DynamicPortal.FinancingCopy2Lease' | translate }}</p>
            </div>
            <div class="col-sm-4">
              <img class="smallimg2" src="static/assets/img/dtf-assets/images/redesign/TEAM_DRIVERS.png">
              <h4> {{ 'DynamicPortal.FinancingTitle3Lease' | translate }}</h4>
              <p class="paragraph2"> {{ 'DynamicPortal.FinancingCopy3Lease' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <section class='mbfs-red-banner-inner'>
    <div class="mbfs-red-banner-inner__box">
      <div class="mbfs-red-banner-inner__box--text">
        <h2 class="mbfs-red-banner-inner__header-title">
          For more information
          <a href="/home/brochures">click here</a>
          to review our brochures or <a href="{{this.targetRedirect}}en/calculator/findealer.do"> {{
            'Header.FindADealer' | translate }}</a>
        </h2>
      </div>
    </div>
  </section> -->




  <!--Copyright footer-->
  <footer id="mbfs-footer">
    <div role="contentinfo">
      <div class="mbfs-copyright">
        <p class="paragraph1"> {{ 'DynamicPortal.DisclaimerLease' | translate }} </p>
      </div>
    </div>
  </footer>
</div>

